import * as XLSX from 'xlsx';

export default class SheetHelper {

    private static readonly JsonConvertOptions: XLSX.Sheet2JSONOpts = { 
      raw: false,
      header: 'A',
      defval: null,
      dateNF: 'yyyy-mm-dd' 
    }; 

    static getSheetAsJson(sheet: XLSX.WorkSheet) {
        if (!sheet) {
          return [];
        }
        const json = XLSX.utils.sheet_to_json(sheet, SheetHelper.JsonConvertOptions);
        json.shift();
        return json;
    }

}
